/**
 * SubscriptionStatusService
 * Service for SubscriptionStatus entity operations
 * Route: api/subscriptionstatuses
 * Controller: SubscriptionStatusesController.cs
 */
import { CrudService } from '../base/CrudService';
export class SubscriptionStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SubscriptionStatusService.DEFAULT_SERVICE_PATH,
            basePath: SubscriptionStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== VIEW METHODS ====================
    async getAllViews() {
        const response = await this.getAllViewsRaw();
        return response.data ?? [];
    }
    getAllViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    async getViewById(id) {
        const response = await this.getViewByIdRaw(id);
        return response.data ?? null;
    }
    getViewByIdRaw(id) {
        const url = this.buildUrl(`views/${id}`);
        return this.http.get(url);
    }
}
SubscriptionStatusService.DEFAULT_SERVICE_PATH = 'suppliers';
SubscriptionStatusService.BASE_PATH = 'api/subscriptionstatuses';
//# sourceMappingURL=SubscriptionStatusService.js.map